<template>
  <d-modal v-if="orderKey !== null" @close="handleClose">
    <d-modal-header>
      <d-modal-title>Update Status</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div
        v-if="loading"
        class="d-flex align-items-center justify-content-center py-5 my-5"
      >
        <odd-spinner :size="36" />
      </div>
      <div v-else>
        <d-form-select v-model="selected" :options="options" />
      </div>
    </d-modal-body>
    <d-modal-footer>
      <d-button class="mx-2" theme="light" @click="handleClose">
        Cancel
      </d-button>
      <async-button
        @click="updateOrderStatus"
        text="Save"
        loadingText="saving..."
        :loading="saving"
      />
    </d-modal-footer>
  </d-modal>
</template>

<script>

export default {
  data() {
    return {
      loading: true,
      saving: false,
      selected: null
    };
  },
  props: {
    orderKey: {
      type: String,
      default: null
    }
  },
  computed: {
    options() {
      return this.$store.state.orderStatusOptions.list
        .filter(option => !option.system_default)
        .map(option => {
          return { value: option.key, text: option.internal_label };
        });
    }
  },
  watch: {
    orderKey(newValue) {
      if (newValue !== null) {
        this.loading = true;
        this.$store.dispatch("orders/get", newValue).then(order => {
          this.selected = order.order_status;
          this.loading = false;
        });
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit("close", false);
    },
    updateOrderStatus() {
      this.saving = true;
      const order = {
        key: this.orderKey,
        order_status: this.selected
      }
      this.$store.dispatch("orders/update", order).then(updatedOrder => {
        this.saving = false;
        this.$emit("close", true);
      });

    }
  }
};
</script>

<style></style>
